import React from "react";
import PropTypes from "prop-types";
import { range } from "lodash";

import { Button } from "semantic-ui-react";

import InfiniteScroll from "components/InfiniteScroll";

import {
  NoProcessMessage,
  ProcessesFieldset,
  ProcessField,
  ProcessFieldPlaceholder,
} from "./components";

function ProcessesField({ processes, disabled }) {
  if (!processes.data.length && !processes.initialFetch && !processes.error) {
    return (
      <ProcessesFieldset>
        <NoProcessMessage />
      </ProcessesFieldset>
    );
  }

  if (processes.error && !processes.loading) {
    return <ProcessesFieldset>{processes.error}</ProcessesFieldset>;
  }

  return (
    <InfiniteScroll
      loadingPage={processes.loading}
      hasMorePages={processes.hasMorePages}
      onLoadMore={processes.readNext}
      style={{ display: "flex", flexDirection: "column" }}
      loadingElement={
        !processes.initialFetch &&
        processes.loading && <ProcessFieldPlaceholder />
      }
      pullNextPageElement={
        <Button
          size="tiny"
          basic
          onClick={processes.readNext}
          style={{
            textAlign: "center",
            alignSelf: "center",
            boxShadow: "none",
          }}
        >
          Load More Processes
        </Button>
      }
    >
      <ProcessesFieldset>
        {processes.initialFetch
          ? range(5).map((n) => {
              return <ProcessFieldPlaceholder key={`placeholder-${n}`} />;
            })
          : processes.data.map((p) => {
              return (
                <ProcessField key={p.id} process={p} disabled={disabled} />
              );
            })}
      </ProcessesFieldset>
    </InfiniteScroll>
  );
}

ProcessesField.propTypes = {
  processes: PropTypes.shape({
    data: PropTypes.array.isRequired,
    initialFetch: PropTypes.bool.isRequired,
    hasMorePages: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    readNext: PropTypes.func.isRequired,
    error: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
};

ProcessesField.defaultProps = { disabled: false };

export default ProcessesField;
